<template>
  <div>
    <v-container fluid>
      <v-skeleton-loader :loading="!flagNav" transition="scale-transition" max-height="64" type="table-heading">
        <v-toolbar :image="SubNavbarBackGround" color="primary" class="header-title text-white">
          <v-toolbar-title class="title" :style="'color: #' + FontColorTitle">{{ $t('_cifZeroInitLog') }}</v-toolbar-title>
          <v-spacer />
          <div class="d-flex pr-4">
            <v-toolbar-title class="title" :style="'color: #' + FontColorTitle">{{ today }}</v-toolbar-title>
          </div>
        </v-toolbar>
      </v-skeleton-loader>

      <v-card class="filter-card mb-4" elevation="0" border rounded="lg">
        <v-card-text class="pa-4">
          <v-row dense align="center">
            <v-col cols="12" sm="6" md="3">
              <v-menu v-model="startMenu" :close-on-content-click="false" transition="scale-transition" offset-y min-width="auto">
                <template v-slot:activator="{ props }">
                  <v-text-field
                    v-bind="props"
                    :model-value="formatDisplayDate(startDate)"
                    readonly
                    clearable
                    label="Start Date"
                    placeholder="Any"
                    variant="outlined"
                    density="comfortable"
                    hide-details
                    prepend-inner-icon="mdi-calendar-start"
                    @click:clear="clearStart"
                  ></v-text-field>
                </template>
                <v-card class="date-picker-card">
                  <v-date-picker
                    v-model="pickerStart"
                    @update:model-value="onStartPicked"
                    :max="endDate || undefined"
                    hide-header
                    show-adjacent-months
                    color="primary"
                    elevation="0"
                    rounded="lg"
                  />
                </v-card>
              </v-menu>
            </v-col>
            <v-col cols="12" sm="6" md="3">
              <v-menu v-model="endMenu" :close-on-content-click="false" transition="scale-transition" offset-y min-width="auto">
                <template v-slot:activator="{ props }">
                  <v-text-field
                    v-bind="props"
                    :model-value="formatDisplayDate(endDate)"
                    readonly
                    clearable
                    label="End Date"
                    placeholder="Any"
                    variant="outlined"
                    density="comfortable"
                    hide-details
                    prepend-inner-icon="mdi-calendar-end"
                    @click:clear="clearEnd"
                  ></v-text-field>
                </template>
                <v-card class="date-picker-card">
                  <v-date-picker
                    v-model="pickerEnd"
                    @update:model-value="onEndPicked"
                    :min="startDate || undefined"
                    hide-header
                    show-adjacent-months
                    color="primary"
                    elevation="0"
                    rounded="lg"
                  />
                </v-card>
              </v-menu>
            </v-col>
            <v-col cols="12" md="4">
              <v-text-field
                v-model="filters.searchTerm"
                label="Search"
                placeholder="Name or screen"
                variant="outlined"
                density="comfortable"
                hide-details
                clearable
                prepend-inner-icon="mdi-magnify"
                @keyup.enter="search"
              ></v-text-field>
            </v-col>
            <v-col cols="12" md="2" class="d-flex justify-end ga-2">
              <v-btn variant="text" color="grey-darken-1" :disabled="loading" @click="reset">Reset</v-btn>
              <v-btn color="primary" :loading="loading" @click="search">Search</v-btn>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>

      <v-card>
        <v-card-title>
          CIF Zero Init Logs
          <v-spacer></v-spacer>
          <span class="text-caption">Total: {{ total }}</span>
        </v-card-title>
        <v-data-table-server
          class="modern-table"
          :headers="headers"
          :items="items"
          :loading="loading"
          :items-per-page="pageSize"
          :page="page"
          :items-length="total"
          @update:options="onTableOptions"
        >
          <template #item.cifNo="{ item }">
            <code>{{ item.cifNo }}</code>
          </template>
          <template #item.createdDate="{ item }">
            {{ formatDateTime(item.createdDate) }}
          </template>
        </v-data-table-server>
      </v-card>
    </v-container>
  </div>
</template>

<script>
export default {
  name: 'CifZeroInitLog',
  inject: ['flagNav', 'FontColorTitle', 'SubNavbarBackGround'],
  data() {
    return {
      loading: false,
      flagNav: true,
      today: null,
      items: [],
      total: 0,
      page: 1,
      pageSize: 10,
      filters: { searchTerm: '' },
      startDate: null,
      endDate: null,
      pickerStart: null,
      pickerEnd: null,
      startMenu: false,
      endMenu: false,
      headers: [
        { title: 'CIF No', value: 'cifNo' },
        { title: 'First Name (TH)', value: 'firstNameTh' },
        { title: 'Last Name (TH)', value: 'lastNameTh' },
        { title: 'First Name (EN)', value: 'firstNameEn' },
        { title: 'Last Name (EN)', value: 'lastNameEn' },
        { title: 'Segment', value: 'segment' },
        { title: 'Wealth', value: 'wealthMembership' },
        { title: 'Language', value: 'language' },
        { title: 'Screen', value: 'screen' },
        { title: 'Theme', value: 'theme' },
        { title: 'Platform', value: 'platform' },
        { title: 'Created', value: 'createdDate' },
      ],
    };
  },
  mounted() {
    this.GetDate();
  },
  methods: {
    GetDate() {
      let today1 = new Date();
      let dd = today1.getDate();
      let mm = today1.getMonth() + 1;
      let yyyy = today1.getFullYear();
      if (dd < 10) dd = '0' + dd;
      if (mm < 10) mm = '0' + mm;
      this.today = dd + '/' + mm + '/' + yyyy;
    },
    onTableOptions({ page, itemsPerPage }) {
      this.page = page;
      this.pageSize = itemsPerPage;
      this.search();
    },
    onStartPicked(val) {
      this.startDate = this.formatStateDate(val);
      this.startMenu = false;
    },
    onEndPicked(val) {
      this.endDate = this.formatStateDate(val);
      this.endMenu = false;
    },
    clearStart() {
      this.startDate = null;
      this.pickerStart = null;
    },
    clearEnd() {
      this.endDate = null;
      this.pickerEnd = null;
    },
    formatStateDate(d) {
      if (!d) return null;
      const dt = typeof d === 'string' ? new Date(d) : d instanceof Date ? d : new Date(d);
      if (Number.isNaN(dt.getTime())) return null;
      const yyyy = dt.getFullYear();
      const mm = String(dt.getMonth() + 1).padStart(2, '0');
      const dd = String(dt.getDate()).padStart(2, '0');
      return `${yyyy}-${mm}-${dd}`;
    },
    formatDisplayDate(dateString) {
      if (!dateString) return '';
      return new Date(dateString).toLocaleDateString('en-GB'); // DD/MM/YYYY
    },
    reset() {
      this.filters = { searchTerm: '' };
      this.startDate = null;
      this.endDate = null;
      this.pickerStart = null;
      this.pickerEnd = null;
      this.page = 1;
      this.search();
    },
    search() {
      this.loading = true;
      const req = {
        startDate: this.startDate ? this.startDate + 'T00:00:00' : null,
        endDate: this.endDate ? this.endDate + 'T23:59:59' : null,
        searchTerm: this.filters.searchTerm || '',
        page: this.page,
        pageSize: this.pageSize,
      };
      this.$call.SearchCifZeroInitLog(
        req,
        (res) => {
          if (res.status === 0) {
            this.items = res.data.items;
            this.total = res.data.totalCount;
          }
          this.loading = false;
        },
        () => {
          this.loading = false;
        }
      );
    },
    formatDateTime(dt) {
      if (!dt) return '-';
      return new Date(dt + 'Z').toLocaleString();
    },
  },
};
</script>

<style scoped>
.filter-card {
  background: rgb(var(--v-theme-surface, 255, 255, 255));
}

.date-picker-card {
  border-radius: 12px !important;
  overflow: hidden;
}

.date-picker-actions {
  border-top: 1px solid #e0e0e0;
  background: #fafafa;
  padding: 8px 12px !important;
}

.date-picker-actions .v-btn {
  min-width: 80px;
  font-weight: 600;
  text-transform: none;
}

.date-picker-actions .v-btn--disabled {
  opacity: 0.5;
}

.modern-table :deep(.v-table__wrapper) {
  max-height: 600px;
  overflow-y: auto;
  scrollbar-width: thin;
  scrollbar-color: rgba(25, 118, 210, 0.3) rgba(0, 0, 0, 0.05);
}

.modern-table :deep(.v-table__wrapper thead th) {
  position: sticky;
  top: 0;
  z-index: 2;
  background: rgb(var(--v-theme-surface, 255, 255, 255));
}

.modern-table :deep(.v-table__wrapper::-webkit-scrollbar) {
  width: 6px;
}

.modern-table :deep(.v-table__wrapper::-webkit-scrollbar-track) {
  background: rgba(0, 0, 0, 0.05);
}

.modern-table :deep(.v-table__wrapper::-webkit-scrollbar-thumb) {
  background: rgba(25, 118, 210, 0.3);
  border-radius: 3px;
}

.modern-table :deep(.v-table__wrapper::-webkit-scrollbar-thumb:hover) {
  background: rgba(25, 118, 210, 0.5);
}
</style>
